import { render, staticRenderFns } from "./FormSchema.vue?vue&type=template&id=7678dda7&scoped=true&"
import script from "./FormSchema.vue?vue&type=script&lang=js&"
export * from "./FormSchema.vue?vue&type=script&lang=js&"
import style0 from "./FormSchema.vue?vue&type=style&index=0&id=7678dda7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678dda7",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem});
